import React, { Fragment, useEffect, useState } from 'react';
import PageWrapper from '../../components/common/PageWrapper';
import { ReportRow } from './ReportRow';
import { Pagination } from 'antd';

export interface IReportItem {
  _id: string;
  department: string;
  customer: string;
  metalType: string;
  jewelleryType: string;
  weightOut: number;
  weightOutCapturedImage: string | null;
  weightIn: number;
  weightInCapturedImage: string | null;
  weightOutTime: string; // ISO date string
  weightInTime: string; // ISO date string
  isCompleted: boolean;
  reportId: string | null;
  qty: number;
  createdBy: string | null;
  updatedBy: string | null;
  children: IReportItem[]; // recursive type for nested children
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  parentId: string | null;
  powderReportId: string | null;
  powderWeight: number | null;
  __v?: number;
}

const initialData: any = [
  {
    _id: '684068148a465950c9700beb',
    department: 'department_d',
    customer: 'test',
    metalType: '10K',
    jewelleryType: 'ring',
    weightOut: 206,
    weightOutCapturedImage: null,
    weightIn: 186,
    weightInCapturedImage: null,
    weightOutTime: '2025-06-04T15:40:10.928Z',
    weightInTime: '2025-06-04T15:40:18.955Z',
    isCompleted: false,
    reportId: null,
    qty: 68,
    createdBy: '67cbe37d2aa0ce9ee4a137c0',
    updatedBy: '67cbe37d2aa0ce9ee4a137c0',
    children: [
      {
        department: 'department_e',
        customer: 'test',
        metalType: '10K',
        jewelleryType: 'ring',
        weightOut: 102,
        weightOutCapturedImage: null,
        weightIn: 83,
        weightInCapturedImage: null,
        weightOutTime: '2025-06-04T15:41:09.220Z',
        weightInTime: '2025-06-04T15:41:13.847Z',
        isCompleted: false,
        reportId: null,
        qty: 68,
        createdBy: null,
        updatedBy: '67cbe37d2aa0ce9ee4a137c0',
        children: [],
        createdAt: '2025-06-04T15:40:26.014Z',
        updatedAt: '2025-06-04T15:41:13.851Z',
        parentId: '684068148a465950c9700beb',
        powderReportId: null,
        powderWeight: null,
        _id: '684068ea8a465950c970139f',
      },
    ],
    createdAt: '2025-06-04T15:36:52.555Z',
    updatedAt: '2025-06-04T15:41:13.851Z',
    parentId: null,
    powderReportId: null,
    powderWeight: null,
    __v: 0,
  },
  {
    _id: '6840651c1c61dea08a6770fd',
    department: 'department_a',
    customer: 'mohammad',
    metalType: '14K',
    jewelleryType: 'ring',
    weightOut: 3.5,
    weightOutCapturedImage: null,
    weightIn: 1.6,
    weightInCapturedImage: null,
    weightOutTime: '2025-06-04T15:24:33.031Z',
    weightInTime: '2025-06-04T15:25:27.421Z',
    isCompleted: false,
    reportId: null,
    qty: 45,
    createdBy: '67cbe37d2aa0ce9ee4a137c0',
    updatedBy: '67cbe37d2aa0ce9ee4a137c0',
    children: [
      {
        department: 'department_b',
        customer: 'mohammad',
        metalType: '14K',
        jewelleryType: 'ring',
        weightOut: 3.5,
        weightOutCapturedImage: null,
        weightIn: 1.6,
        weightInCapturedImage: null,
        weightOutTime: '2025-06-04T15:24:33.031Z',
        weightInTime: '2025-06-04T15:25:27.421Z',
        isCompleted: false,
        reportId: null,
        qty: 45,
        createdBy: null,
        updatedBy: '67cbe37d2aa0ce9ee4a137c0',
        children: [],
        createdAt: '2025-06-04T15:25:30.934Z',
        updatedAt: '2025-06-04T15:42:29.836Z',
        parentId: '6840651c1c61dea08a6770fd',
        powderReportId: null,
        powderWeight: null,
        _id: '6840656a1c61dea08a6777cb',
      },
      {
        department: 'department_c',
        customer: 'mohammad',
        metalType: '14K',
        jewelleryType: 'ring',
        weightOut: 45,
        weightOutCapturedImage: null,
        weightIn: 34,
        weightInCapturedImage: null,
        weightOutTime: '2025-06-04T15:24:33.031Z',
        weightInTime: '2025-06-04T15:25:27.421Z',
        isCompleted: false,
        reportId: null,
        qty: 45,
        createdBy: null,
        updatedBy: '67cbe37d2aa0ce9ee4a137c0',
        children: [],
        createdAt: '2025-06-04T15:30:06.037Z',
        updatedAt: '2025-06-04T15:42:33.439Z',
        parentId: '6840651c1c61dea08a6770fd',
        powderReportId: null,
        powderWeight: null,
        _id: '6840667e1c61dea08a677b7a',
      },
    ],
    createdAt: '2025-06-04T15:24:12.028Z',
    updatedAt: '2025-06-04T15:42:33.439Z',
    parentId: null,
    powderReportId: null,
    powderWeight: null,
    __v: 0,
  },
  {
    _id: '684060e36ce8f64b11f8a433',
    department: 'department_e',
    customer: 'test_1',
    metalType: '14K',
    jewelleryType: 'bracelet',
    weightOut: 5.4,
    weightOutCapturedImage: null,
    weightIn: 1.3,
    weightInCapturedImage: null,
    weightOutTime: '2025-06-04T15:06:34.301Z',
    weightInTime: '2025-06-04T15:06:38.882Z',
    isCompleted: false,
    reportId: null,
    qty: 20,
    createdBy: '67cbe37d2aa0ce9ee4a137c0',
    updatedBy: '67cbe37d2aa0ce9ee4a137c0',
    children: [],
    createdAt: '2025-06-04T15:06:11.701Z',
    updatedAt: '2025-06-04T15:06:41.904Z',
    parentId: null,
    powderReportId: null,
    powderWeight: null,
    __v: 0,
  },
  {
    _id: '684060d86ce8f64b11f8a2ad',
    department: 'department_c',
    customer: 'mohammad',
    metalType: 'Silver',
    jewelleryType: 'ring',
    weightOut: 205.5,
    weightOutCapturedImage: null,
    weightIn: 100.2,
    weightInCapturedImage: null,
    weightOutTime: '2025-06-04T15:06:52.752Z',
    weightInTime: '2025-06-04T15:06:55.647Z',
    isCompleted: false,
    reportId: null,
    qty: null,
    createdBy: '67cbe37d2aa0ce9ee4a137c0',
    updatedBy: '67cbe37d2aa0ce9ee4a137c0',
    children: [],
    createdAt: '2025-06-04T15:06:00.847Z',
    updatedAt: '2025-06-04T15:07:09.128Z',
    parentId: null,
    powderReportId: null,
    powderWeight: null,
    __v: 0,
  },
  {
    _id: '6840607c6ce8f64b11f89c98',
    department: 'department_a',
    customer: 'husain',
    metalType: '10K',
    jewelleryType: 'bracelet',
    weightOut: 1.2,
    weightOutCapturedImage: null,
    weightIn: 1,
    weightInCapturedImage: null,
    weightOutTime: '2025-06-04T15:04:49.479Z',
    weightInTime: '2025-06-04T15:05:47.916Z',
    isCompleted: false,
    reportId: null,
    qty: 10,
    createdBy: '67cbe37d2aa0ce9ee4a137c0',
    updatedBy: '67cbe37d2aa0ce9ee4a137c0',
    children: [],
    createdAt: '2025-06-04T15:04:28.977Z',
    updatedAt: '2025-06-04T15:05:47.918Z',
    parentId: null,
    powderReportId: null,
    powderWeight: null,
    __v: 0,
  },
];

export default function TaskAssignment() {
  const [data, setData] = useState<any>(initialData);
  const [expandedIds, setExpandedIds] = useState(new Set());
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const totalPages = Math.ceil(data.length / rowsPerPage);
  const currentData = data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  const toggleExpand = (id: string) => {
    setExpandedIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  useEffect(() => {
    const initiallyExpanded = new Set();
    currentData.forEach((item: IReportItem) => {
      if (item.children && item.children.length > 0) {
        initiallyExpanded.add(item._id);
      }
    });
    setExpandedIds(initiallyExpanded);
  }, []);

  const columns = [
    { label: '', width: '40px' },
    { label: 'Department', width: '120px' },
    { label: 'Customer', width: '120px' },
    { label: 'Metal Type', width: '100px' },
    { label: 'Jewellery Type', width: '120px' },
    { label: 'Qty', width: '100px' },
    { label: 'Weight Out', width: '100px' },
    { label: 'Weight Out Image', width: '120px' },
    { label: 'Weight In', width: '100px' },
    { label: 'Weight In Image', width: '120px' },
    { label: 'Weight Out Timestamp', width: '170px' },
    { label: 'Weight In Timestamp', width: '170px' },
    { label: 'Diff', width: '80px' },
    // { label: 'Created At', width: '150px' },
    { label: 'Actions', width: '120px' },
  ];

  return (
    <PageWrapper className="px-4 py-4 h-[calc(100vh-80px)] flex flex-col">
      <div className="bg-white rounded-lg shadow-xl flex-1 flex flex-col overflow-hidden">
        {/* Table Wrapper: Scrollable */}
        <div className="overflow-auto flex-1">
          <table className="min-w-full table-auto">
            <thead className="text-center sticky top-0 z-10 bg-meta-9">
              <tr className="">
                {columns.map((col, index) => (
                  <th
                    key={index}
                    className={`px-3 py-2 text-sm font-semibold bg-meta-9 ${col.width}`}
                    style={{ width: col.width }}
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentData.map((item: IReportItem, index: number) => (
                <Fragment key={item._id}>
                  <ReportRow
                    item={item}
                    index={index}
                    isChild={false}
                    isExpanded={expandedIds.has(item._id)}
                    toggleExpand={toggleExpand}
                  />
                  {expandedIds.has(item._id) &&
                    item.children.map(child => <ReportRow key={child._id} index={index} item={child} isChild={true} />)}
                  <tr>
                    <td colSpan={100} className="py-2"></td>
                  </tr>
                </Fragment>
              ))}
            </tbody>
          </table>
        </div>

        {/* Sticky Pagination at Bottom */}
        <div className="border-t p-4 sticky bottom-0 bg-white z-20">
          <Pagination
            current={currentPage}
            pageSize={rowsPerPage}
            total={data.length}
            showSizeChanger={false}
            onChange={page => setCurrentPage(page)}
          />
        </div>
      </div>
    </PageWrapper>
  );
}
